<template>
  <v-content>
    <v-container class="py-5 px-5" fluid v-if="this.$store.state.signedIn">
      <v-layout justify-center wrap>
        <v-flex xs12>
          <v-toolbar color="secondary" dark height="96px">
            <v-toolbar-title class="white--text" :style="$store.state.textFormatting.headers"> 
              Username: {{userInfo.username}}, Name: {{userInfo.given_name}} {{userInfo.family_name}}, Email: {{userInfo.email}}  
              <v-divider  v-if="showEditUser"></v-divider>
              
              <div v-if="showEditUser" :style="$store.state.textFormatting.headers">Toggle attributes to open edit window</div>
            </v-toolbar-title>
            <v-spacer> </v-spacer> 
            <v-tooltip top color="primary" id="editUserAttributes">
                 <span :style="$store.state.textFormatting.main">Edit User Attributes</span>
                <template v-slot:activator="{ on }">
                  <v-btn color="green" icon v-on="on" @click="showEditUser = !showEditUser; showChangePassword=false" :style="$store.state.textFormatting.main"> <v-icon> account_circle </v-icon></v-btn>
                </template>
              </v-tooltip>
              <v-tooltip top color="primary" id="editUserAttributes">
                 <span :style="$store.state.textFormatting.main">Change Password</span>
                <template v-slot:activator="{ on }">
                  <v-btn color="green" icon v-on="on" @click="showChangePassword = !showChangePassword; showEditUser=false" :style="$store.state.textFormatting.main"> <v-icon> lock </v-icon></v-btn>
                </template>
              </v-tooltip>
              <info>
                <template>
                    Individual user settings
                </template>
                <template slot="body">
                    <p> Press the <v-icon> account_circle </v-icon> icon to edit your user attributes.</p>
                    <br>
                    <p> Press the <v-icon> lock </v-icon> icon to receive a code via email to edit your password.</p>
                    <br />
                </template>
              </info>
          </v-toolbar>
          <v-card>
            <v-card-text>
              
             
            </v-card-text>
          </v-card>
          <v-card v-if="showEditUser">
            <v-card-text>
              <v-layout wrap>
                <v-flex xs12 md8 xl4 class="px-2">
                  <v-card>
                    <v-card-actions>
                      <v-layout wrap>
                        <v-flex xs12 xl10> <p :style="$store.state.textFormatting.main"> Username: {{userInfo.username}}  </p> </v-flex>
                        <v-flex xs12 xl10> <p :style="$store.state.textFormatting.main"> Please contact your organisation admin to edit your username, via 'Organisation Admin' </p> </v-flex>

                        <!--

                        <v-switch v-model="usernameSwitch"> </v-switch>
                        <v-flex xs12 v-if="usernameSwitch"> 
                          <v-card>
                            <v-card-text>
                              <v-text-field v-model="username_InfoChange" :counter="32" :rules="UsernameRules" label="Username"></v-text-field>
                            </v-card-text>
                            <v-card-actions>
                              <v-btn color="green" dark @click="submitNewAttribute('username', userInfo.username)"> SUBMIT </v-btn>
                            </v-card-actions>
                          </v-card>
                        </v-flex>

                        !-->
                      </v-layout>
                    </v-card-actions>
                  </v-card>
                </v-flex>
                <v-flex xs12 md8 xl4 class="px-2">
                  <v-card>
                    <v-card-actions>
                      <v-layout wrap>
                        <v-flex xs12 xl10> <p :style="$store.state.textFormatting.main"> Name: {{userInfo.given_name}} {{userInfo.family_name}}  </p> </v-flex>
                        <v-switch v-model="nameSwitch"> </v-switch>
                        <v-flex xs12 v-if="nameSwitch"> 
                          <v-card>
                            <v-card-text>
                              <v-text-field v-model="given_NameInfoChange" :counter="32" :rules="nameRules" label="Given Name" :style="$store.state.textFormatting.main"></v-text-field>
                              <v-text-field v-model="family_NameInfoChange" :counter="32" :rules="nameRules" label="Family Name" :style="$store.state.textFormatting.main"></v-text-field>
                            </v-card-text>
                            <v-card-actions>
                              <v-btn color="green" dark @click="submitNewAttribute('name', userInfo.username)" :style="$store.state.textFormatting.main"> SUBMIT </v-btn>
                            </v-card-actions>
                          </v-card>
                        </v-flex>
                        <v-flex xs12 v-if="!nameSwitch">
                          <v-card class="justify-right" color="success" v-if="nameMsg">
                              <h3 :style="$store.state.textFormatting.main"> {{ nameMsg }} </h3>
                          </v-card>
                        </v-flex>
                      </v-layout>
                    </v-card-actions>
                  </v-card>
                </v-flex>
                <v-flex xs12 md8 xl4 class="px-2">
                  <v-card>
                    <v-card-actions>
                      <v-layout wrap>
                        <v-flex xs12 xl10> <p :style="$store.state.textFormatting.main"> Email: {{userInfo.email}} </p> </v-flex>
                        <v-switch v-model="emailSwitch">   </v-switch>
                        <v-flex xs12 v-if="emailSwitch"> 
                          <v-card>
                            <v-card-text>
                              <v-text-field v-model="email_InfoChange" :counter="32" :rules="emailRules" label="Email Address" :style="$store.state.textFormatting.main"></v-text-field>
                            </v-card-text>
                            <v-card-actions>
                              <v-btn color="green" dark @click="submitNewAttribute('email', userInfo.username)" :style="$store.state.textFormatting.main"> SUBMIT </v-btn>
                            </v-card-actions>
                          </v-card>
                        </v-flex>
                        <v-flex xs12 v-if="!emailSwitch">
                          <v-card class="justify-right" color="success" v-if="emailMsg">
                            <h3 :style="$store.state.textFormatting.main">
                              {{ emailMsg }}
                            </h3>
                          </v-card>
                        </v-flex>
                      </v-layout>
                    </v-card-actions>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
          <v-card v-if="showChangePassword">
            <v-card-text>
              <v-form ref="ChangePassword" lazy-validation>
                <h3 :style="$store.state.textFormatting.main"> 
                    In order to change your password we will send you a code via email. 
                    Press 'send email' to receive code via email: 
                  <v-btn color="green" dark @click="sendForgotEmailCode(userInfo.username)" :style="$store.state.textFormatting.main"> Send Email   
                  </v-btn>
                </h3>
                <h3 color="red" :style="$store.state.textFormatting.main"> {{message}} </h3>
                <v-divider v-if="NewPasswordEmailSendForm"></v-divider>
                <div v-if="NewPasswordEmailSendForm">
                    <h3 :style="$store.state.textFormatting.main">
                        Please enter the code - sent via email -  and new password. Then select submit.
                    </h3>
                    <v-layout> 
                      <v-flex xs12 md6 class="px-2">
                        <v-text-field :style="$store.state.textFormatting.main" label="Code"  :rules="codeRules" v-model="code" v-on:keyup.enter="SendNewPassword(userInfo.username, code, password)"></v-text-field>
                      </v-flex>
                      <v-flex xs12 md6 class="px-2">
                        <v-text-field 
                          :style="$store.state.textFormatting.main"
                          label="New Password" 
                          :rules="passwordRules" 
                          v-model="password" min="8" 
                          :append-icon="show4 ? 'visibility' : 'visibility_off'"
                          @click:append="show4 = !show4" 
                          :type="show4 ? 'text' : 'password'" 
                          required 
                          v-on:keyup.enter="SendNewPassword(userInfo.username, code, password)"></v-text-field>
                      </v-flex>
                    </v-layout>
                    
                    <v-btn :style="$store.state.textFormatting.main" color="green" dark @click="SendNewPassword(userInfo.username, code, password)"> Submit </v-btn>
                </div>
              </v-form>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>

      <br />

      <v-layout justify-center align-center>
        <v-flex xs12 class="py-2">
          <v-toolbar color="secondary" dark>
            <v-toolbar-title :style="$store.state.textFormatting.headers">
              Alert Emails Settings
            </v-toolbar-title>
            <v-progress-circular v-if="email_loading" indeterminate color="purple" />
            <v-spacer />
            <info>
              <template>
                  Alert Email Settings
              </template>
              <template slot="body">
                  <p> 
                    Designate whether you will receive email alerts for 
                    <v-btn small @click="routeNewWindow('Organisation Alerts')" color="success" :style="$store.state.textFormatting.main">organisation alerts</v-btn>
                     or 
                    <v-btn small @click="routeNewWindow('User Alerts')" color="success" :style="$store.state.textFormatting.main">user alerts</v-btn>
                    the system has generated. 
                  </p>
                  <p> 
                    <b>NOTE:</b> Each ASN or prefix will have to have emails enabled also e.g. to receive  <b>organisation</b> email alerts for <b>AS 2</b>:
                    <ol>
                    
                      <li>
                        Enable emails under settings in 
                        <v-btn small @click="routeNewWindow('ASN Settings')" color="success" :style="$store.state.textFormatting.main">ASNs</v-btn>
                        page (for <b>AS 2</b>). 
                      </li>
                      <li>
                        Enable organisation email alerts (for <b>each user</b> who wishes to receive them) in this page. 
                      </li>
                    </ol>
                  </p>
              </template>
            </info>

          </v-toolbar>
          <v-card>
            <v-card-text v-if="!email_loading">
              <v-layout align-center justify-center>
                <v-flex class="px-2" xs3>
                  <v-tooltip top eager close-delay=500 >
                      <template  v-slot:activator="{ on }">
                          <v-switch slot="activator" v-on="on" v-model="change_settings[0]">
                              <template v-slot:label>
                                  <div :style="$store.state.textFormatting.main" v-on="on">Organisation Alert Emails</div>
                              </template> 
                          </v-switch>
                      </template>
                  <span :style="$store.state.textFormatting.main">
                    Whether <b>this user ({{ $store.state.user.username }})</b> will receive emails on <b>organisation alerts</b>.
                  </span>
                  </v-tooltip>
                  <v-tooltip top eager close-delay=500 >
                      <template  v-slot:activator="{ on }">
                          <v-switch slot="activator" v-on="on" v-model="change_settings[2]">
                              <template v-slot:label>
                                  <div :style="$store.state.textFormatting.main" v-on="on">Include Intra-Org Alerts</div>
                              </template> 
                          </v-switch>
                      </template>
                  <span :style="$store.state.textFormatting.main">
                    Whether <b>this user ({{ $store.state.user.username }})</b> will receive emails on <b>organisation alerts</b> including <b>Intra-Organisation</b> ASN changes.
                  </span>
                  </v-tooltip>

                </v-flex>
                <v-flex class="px-2" xs3>
                  <v-tooltip top eager close-delay=500 >
                      <template  v-slot:activator="{ on }">
                          <v-switch slot="activator" v-on="on" v-model="change_settings[1]">
                              <template v-slot:label>
                                  <div :style="$store.state.textFormatting.main" v-on="on">User Alert Emails</div>
                              </template> 
                          </v-switch>
                      </template>
                  <span :style="$store.state.textFormatting.main">
                    Whether <b>this user ({{ $store.state.user.username }})</b> will receive emails on <b>user alerts</b>.
                  </span>
                  </v-tooltip>
                  <v-tooltip top eager close-delay=500 >
                      <template  v-slot:activator="{ on }">
                          <v-switch slot="activator" v-on="on" v-model="change_settings[3]">
                              <template v-slot:label>
                                  <div :style="$store.state.textFormatting.main" v-on="on">Include Intra-Org Alerts</div>
                              </template> 
                          </v-switch>
                      </template>
                  <span :style="$store.state.textFormatting.main">
                    Whether <b>this user ({{ $store.state.user.username }})</b> will receive emails on <b>user alerts</b> including <b>Intra-Organisation</b> ASN changes..
                  </span>
                  </v-tooltip>
                </v-flex>
                <v-flex class="px-2" shrink>
                  
                  <v-tooltip top eager close-delay=500 >
                      <template  v-slot:activator="{ on }">
                          <div slot="activator" v-on="on">
                            <v-btn :disabled="same_settings||email_submitting" @click="submitEmailSettings()" color="success" :style="$store.state.textFormatting.main">Submit Changes</v-btn>
                          </div>
                      </template>
                  <span :style="$store.state.textFormatting.main">
                    Submit changes to email settings (disabled if settings haven't changed)
                  </span>
                  </v-tooltip>
                </v-flex>
                <v-flex shrink>
                  <v-progress-circular v-if="email_submitting" indeterminate color="purple" />
                </v-flex>
              </v-layout>
              <v-layout align-center justify-center>
                <v-flex shrink class="px-2 py-2">
                  <v-card color="success">
                    <v-card-text :style="$store.state.textFormatting.main">
                      {{ updated_str }}
                    </v-card-text>
                  </v-card>
                </v-flex>
              </v-layout>

            </v-card-text>
          </v-card>


        </v-flex>
      </v-layout>

      <v-layout justify-center align-center>
        <v-flex xs12 class="py-2">
          <v-toolbar color="secondary" dark>
            <v-toolbar-title :style="$store.state.textFormatting.headers">
              User Defined Website Settings
            </v-toolbar-title>
            <v-spacer />
            <info>
              <template>
                  User Defined Website Settings
              </template>
              <template slot="body">
                  <p> 
                    Various settings for the website in general can be tweaked from here (and can also be changed from the respective pages).
                  </p>
                  <p> <b>NOTE:</b> These changes will only apply once the website has been refreshed on the given page (if changing settings from a separate window). </p>
                  <v-divider />
                  <p> <b>UPCOMING:</b> Ability to save these settings to the central system, so they will persist when using a new browser or removing cookies </p>
              </template>
            </info>

          </v-toolbar>
          <v-card>
            <v-card-text>
              <v-flex xs12>
                <v-layout v-for="(value, name) in currentShowSettings" :key="name">
                  <v-flex>
                    <v-switch v-model="currentShowSettings[name]" @change="storeShowChanges()">
                      <template v-slot:label>
                        <div :style="$store.state.textFormatting.main">{{showTranslations[name]}}</div>
                      </template> 
                    </v-switch>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-card-text>
          </v-card>


        </v-flex>
      </v-layout>

    </v-container>
  </v-content>
</template>

<script>

import info from '../../shared/operational/infopopout.vue'
import { Auth } from 'aws-amplify';
import { API, graphqlOperation } from 'aws-amplify';


    export default {
      name: 'adduser',
      components: {
        info
      },
    data () {
      return {
        message: null,
        id: null,
        emailMsg: false,
        nameMsg: false,
        show4: false,
        code: null,
        password: null,
        NewPasswordEmailSendForm: false,
        showEditUser: false,
        showChangePassword: false,
        ButtonNames: [{name: "Username"},{name: "Family Name"},{name: "Given Name"},{name: "UserType"},{name: "Email Address"}],
        dontShow:false,
        editAttribute: {},
        usernameSwitch: false,
        nameSwitch: false,
        emailSwitch: false,
        userTypeSwitch: false,
        newAttribute: "",
        username_InfoChange: null,
        family_NameInfoChange: null,
        given_NameInfoChange: null,
        email_InfoChange: null,
        emailRules: [ v => !!v || 'E-mail is required', v => /.+@.+/.test(v) || 'E-mail must be valid' ],
        nameRules: [ v=> !!v || 'Name', v => /^[a-zA-Z]+$/.test(v) || 'Name must be Valid' ], //Check Regexworks
        codeRules: [ v => !!v || 'A valid 6 digit code is required', v => /^[0-9]{6}$/.test(v) || 'Must be a valid 6 digit number' ],
        passwordRules: [ v => !!v || 'A valid password is required', v => /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&_])[A-Za-z\d@$!%*?&_]{8,}$/.test(v) || 'Password must be over 8 characters long and contain 1 uppercase, 1 lowercase, 1 special char (@$!%*?&_) and 1 number'],
        userInfo: [],
        change_settings:[
          false,
          false
        ],
        saved_settings:[
          false,
          false
        ],
        same_settings: true,
        email_loading: false,
        organisation: '',
        username: '',
        email_submitting: false,
        updated_str: '',
        currentShowSettings: this.$store.state.showSettings,
        showTranslations: {
          'gettingStarted': "Display 'Getting Started' box on homepage",
          'advancedSettings': "Display 'Advanced Settings' for ASNs / Restricted Prefixes",
          'clickthroughAdvFields': "Display 'Advanced Fields' on alert inspection page",
          'autoMerge': 'Auto-merge alerts on organisation / user alerts pages',
          'showRules': 'Show ASN alert on organisation / user alerts pages',
          'showBubble': 'Show bubble Charts on alerts pages',
          'showOrgResSummary': 'Show restricted prefix summary on organisation alerts page',
          'showUserResSummary': 'Show restricted prefix summary on user alerts page',
          'showOrgASNSummary': 'Show monitoring ASNs summary on organisation alerts page',
          'showUserASNSummary': 'Show user monitoring ASNs on user alerts page',
        },
        showActive: false
                  
      }
    },
    computed: {
      isDisabled: function () {
        if (this.userInfo.user_tier == "Admin") {
          return true
        } else {
          return false
        }
      }
    },
     
    beforeMount () {
      this.updateUser();
      try {
        if(this.$store.state.user != null) {
          this.organisation = this.$store.state.user.organisation;
          this.username = this.$store.state.user.username;
        } else {
          this.$store.state.user={}
          this.$store.state.user.username="";
          location.reload()
        }
      } catch (err) {
          console.log(err)
          location.reload()
      }

      this.currentShowSettings = this.$store.state.showSettings
      // console.log(this.$store.state.showSettings)
      // console.log(this.currentShowSettings)
      this.showActive = true
    },

  mounted () {
    this.getEmailSettings();
  },
    methods: {
      storeShowChanges: async function () {
        console.log(this.currentShowSettings)
        if (this.showActive) {
          console.log("COMMITIITNG CHANGES")
          this.$store.commit("setShowSettings", this.currentShowSettings)
        }
      },
      submitEmailSettings: async function () {
        this.email_submitting = true;
        try {
          var email_set_str = ''
          for (var i = 0 ; i < 4 ; i++ ) {
            if (this.change_settings[i]) {
              email_set_str += '1'
            } else {
              email_set_str += '0'
            }
          }
          
          var query = `
            mutation updateUserSettings {
              updateUserSettings (
                p_user: "` + this.username + `",
                p_organisation: "` + this.organisation + `"
                p_send_emails: "` + email_set_str + `"
                p_min_max: "1001"
              ) {
                response
              }
            }
          `;
          console.log(query)
          const  responseObj  = await API.graphql(graphqlOperation(query));
          //var response = responseObj.data.updateUserSettings
          //console.log(response)
          this.email_submitting = false;
          this.getEmailSettings();

        } catch (e) {
          console.log(e)
          this.email_submitting = false;
        }
      },
      getEmailSettings: async function () {
        this.email_loading = true;
        try {
          var query = `
            query getUserSettings {
              getUserSettings (
                p_user: "` + this.username + `",
                p_organisation: "` + this.organisation + `"
              ) {
                send_emails
                min_max_settings
                updated_ts
              }
            }
          `;
          //console.log(query)
          const  settingsObj  = await API.graphql(graphqlOperation(query));
          var usr_settings = settingsObj.data.getUserSettings
          //console.log(usr_settings)
          if (!usr_settings || usr_settings.length == 0) {
            this.updated_str = 'Never been updated, timestamp of last update will appear here';
            this.saved_settings = [
              false,
              false,
              false,
              false
            ];
            this.change_settings = [
              false,
              false,
              false,
              false
            ];
            this.email_loading = false;
          } else {
            if (usr_settings[0].send_emails) {
              const updated_t_split = usr_settings[0].updated_ts.split("T")
              this.updated_str = 'Last updated at (system time): ' + updated_t_split[1].split(".")[0] + " (" + updated_t_split[0] + ")";
              for (var i = 0 ; i < usr_settings[0].send_emails.length ; i++ ) {
                if (usr_settings[0].send_emails[i] == '1') {
                  this.change_settings[i] = true
                  this.saved_settings[i] = true
                } else {
                  this.change_settings[i] = false
                  this.saved_settings[i] = false
                }
              }
              this.email_loading = false;
            }
          }
        } catch (e) {
          console.log(e)
          this.email_loading = false;
        }
      },
      routeNewWindow: async function (input) {
          let routeData = this.$router.resolve({name: input});
          window.open(routeData.href, '_blank');
      },
      updateUser: async function () {
        let user = await Auth.currentAuthenticatedUser();
        let userinf = await Auth.currentUserInfo();
        console.log(user);
        console.log(userinf);
        var userDetailsFormatted = this.formatUpdateUserData(user, userinf);
        console.log(userDetailsFormatted);
        this.$store.state.user = userDetailsFormatted;
        this.userInfo = this.$store.state.user;

      },
      formatUpdateUserData: function(i, j) {
        try {
          var userDetails = {
            "username": i.username,
            "email": j.attributes.email,
            "email_verified": j.attributes.email_verified,
            "family_name": j.attributes.family_name,
            "given_name": j.attributes.given_name,
            "organisation": i.attributes.locale,
            "user_type": i.attributes.name,
            "sub": i.attributes.sub,
            "login_time": i.signInUserSession.accessToken.payload.auth_time
          }
          return userDetails
            
        } catch (err) { // Needs to be some logic here to ensure the user has signed in and maybe redirect to adit there user as the creds arent there.
          this.homepage = false;
          this.$store.state.signedIn = false; 
          this.$store.state.user = "";
        }
      },
      submitNewAttribute: async function (AttType, username) {
        
        switch (AttType) {
          case "username": {
            var newUsername = {username: this.username_InfoChange}
            this.editUserAttributes(username, newUsername)
            break;
          }
          case "name": {
            this.nameMsg = false;
            var newName = {family_name: this.family_NameInfoChange, given_name: this.given_NameInfoChange}
            this.editUserAttributes(username, newName, 'name')
            this.nameSwitch = false;
            break;
          }
          case "email":
            this.emailMsg = false;
            var newEmail = {email: this.email_InfoChange}
            this.editUserAttributes(username, newEmail, 'email')
            this.emailSwitch = false;
            break;

          default:
            console.log("ERROR")
        }

        const CHANGEATT = await Auth.currentAuthenticatedUser();

      },
      editUserAttributes: async function (username, keyValue, type) {
        //console.log(keyValue);

        let user = await Auth.currentAuthenticatedUser();
        //console.log(user);

        try {
          const editUser = await Auth.updateUserAttributes(user, keyValue);
          console.log("FINISHED");
          if (type == 'name') {
            this.nameMsg = editUser;
            this.nameSwitch = false;
          } else if (type == 'email') {
            this.emailMsg = editUser;
            this.emailSwitch = false;
          }
          
          console.log(editUser);
        } catch(err) {
          this.message = (err.message);
          console.log(err);
        }
        
        this.updateUser();

      },
      signup: async function () {
        try {
      
          if (this.$refs.form.validate()) {
            const username = await Auth.currentAuthenticatedUser();
             if (username.username != "TopLevelAdmin") {
               this.form.attributes.locale = username.attributes.locale
             }
            const signup = await Auth.signUp(this.form);
            this.message = "Success, a user has been created"
            this.$refs.form.reset()
        }
        } catch(err){
          this.message = (err.message)
          console.log(err)
        }
      },
      sendForgotEmailCode: function (username) {
            try {
                Auth.forgotPassword(username)
                .then(data =>  {
                    this.NewPasswordEmailSendForm= true
                    this.message=null
                    console.log(data)}
                    )
                .catch(err => {
                    this.message=err.message
                    this.NewPasswordEmailSendForm= false
                }); 
            }
            catch (err) {
                this.message="User does not exist"
            }
      },
      SendNewPassword: function (username, code, new_password) {
            try {
                Auth.forgotPasswordSubmit(username, code, new_password)
                    .then(data =>  {
                        this.message="Success, your password has been changed"
                        console.log(data)
                    })
                    .catch(err => console.log(err));
                    this.currentPage = "Sign In"
                    this.$refs.ChangePassword.reset()
            } catch (err) {
                console.log(err)
            }
            
      },
  },
  watch: {
    change_settings (n) {
      if (this.change_settings[0] == this.saved_settings[0] && this.change_settings[1] == this.saved_settings[1] && this.change_settings[2] == this.saved_settings[2] && this.change_settings[3] == this.saved_settings[3]) {
        this.same_settings = true
      } else {
        this.same_settings = false
      }
    }
  }
}
</script>